import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import LandingPage from "@/pages/LandingPage";
import SellerGuidePage from "@/pages/SellerGuidePage";
import BuyerGuidePage from "@/pages/BuyerGuidePage";
import TestimonialsPage from "@/pages/TestimonialsPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/seller-guide" element={<SellerGuidePage />} />
            <Route path="/buyer-guide" element={<BuyerGuidePage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
